import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(({ palette, custom }) => ({
  root: {
    fontSize: 12,
  },
}));

export default useStyles;
